var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { BButton } from "bootstrap-vue";
import FormCard from "@/components/Form/FormCard.vue";
import FormDisplay from "@/components/Form/FormDisplay.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InstanceForm',
    props: {
        title: null,
        inputs: { default: undefined },
        submitTitle: null,
        loadingMessage: null
    },
    emits: ["onSubmit"],
    setup(__props, { emit }) {
        let formData;
        function onChange(incoming) {
            formData = incoming;
        }
        function handleSubmit() {
            return __awaiter(this, void 0, void 0, function* () {
                emit("onSubmit", formData);
            });
        }
        return { __sfc: true, emit, formData, onChange, handleSubmit, BButton, FormCard, FormDisplay, LoadingSpan };
    }
});
